import { Box, Content, Divider } from '@eluve/components';
import { CancelledAppointmentDisplay } from '@eluve/frontend-feature-appointment';
import { AppointmentName, EluveAdminOnly } from '@eluve/smart-blocks';

import { AppointmentFilesDrawer } from './AppointmentFilesDrawer';
import { appointmentLayoutStyles } from './appointmentLayoutStyles';
import { ReadonlyAppointmentDetails } from './components/ReadonlyAppointmentDetails';

interface CancelledAppointmentLayoutProps {
  appointmentId: string;
}

export const CancelledAppointmentLayout: React.FC<
  CancelledAppointmentLayoutProps
> = ({ appointmentId }) => {
  return (
    <>
      <ReadonlyAppointmentDetails appointmentId={appointmentId} />
      <Content padded>
        <Box vStack className={appointmentLayoutStyles()}>
          <Box spaceBetween fullWidth className="p-2">
            <AppointmentName readonly />
            <EluveAdminOnly>
              <AppointmentFilesDrawer />
            </EluveAdminOnly>
          </Box>
          <Divider />
          <CancelledAppointmentDisplay />
        </Box>
      </Content>
    </>
  );
};
